


























import { Component, Prop, Vue } from 'vue-property-decorator';
import ModuleCard from '@/components/Modules/ModuleCard.vue';
import draggable from 'vuedraggable';
import { Cutoverplan, Module } from '@/types';
import AddModuleDialog from '@/components/Dialogues/AddModuleDialog.vue';
import axios from 'axios';
import env from '@/env';

@Component({
  components: { AddModuleDialog, ModuleCard, draggable }
})
export default class EditCutoverplanModuleTab extends Vue {
  @Prop({ default: () => [] })
  modules!: Module[];

  @Prop()
  cutoverplan?: Cutoverplan;

  @Prop()
  selectedEnvironment!: number;

  dragOptions = {
    animation: 0,
    group: 'description',
    disabled: false,
    ghostClass: 'ghost'
  };

  duplicateModule(): string {
    const duplicateModules: string[] = [];
    this.modules.forEach((module: Module) => {
      const duplicate = !!this.modules.find(
        (duplicateModule) =>
          module.blueprint_id === duplicateModule.blueprint_id && module.id !== duplicateModule.id
      );
      if (duplicate && !duplicateModules.includes(module.name)) duplicateModules.push(module.name);
    });

    return duplicateModules.join('", "');
  }

  async loadModule(module_id: number) {
    const modulePromise = axios.get(`${env.backend_url}/module/${module_id}`);
    const stepsPromise = axios.get(`${env.backend_url}/module/all_steps/${module_id}`);

    const module = (await modulePromise).data;
    module.steps = (await stepsPromise).data;
    this.modules?.push(module);
  }

  async removeBlueprint(blueprint: Module) {
    if (this.modules) this.modules.splice(this.modules?.indexOf(blueprint), 1);
  }
}
